const state = {
    siteInfo: {},
};

const mutations = {
    SET_SITE_INFO(state, data) {
        state.siteInfo = data;
    },
};

const actions = {};

const getters = {};

export default {
    namespaced: true, // 推荐开启命名空间
    state,
    mutations,
    actions,
    getters,
};
